export default __webpack_public_path__ + "static/media/companyLogo2.67c78eaf.png";